import { MenuItem } from '@material-ui/core';
import styled from 'styled-components';

const StyledItem = styled(MenuItem)`
  gap: 10px;
`

export default StyledItem;
